module.exports = __webpack_public_path__ + "static/media/ic-calendar.f8224755.svg";